
import Vue from "vue";
export default Vue.extend({
  name: "InstructionsDialogBox",
  props: {
    dialog: {
      type: Boolean,
      default: true
    },
    instructions: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      dialogShow: false
    };
  },
  watch: {
    dialog: {
      handler(val) {
        this.dialogShow = val;
      },
      deep: true, // Watches nested changes inside `dialog` (if it's an object)
      immediate: true // Runs once when component is created/mounted
    }
  },
  methods: {
    onAccept() {
      this.dialogShow = false;
      this.$emit("accept-dialog", false);
    }
  }
});
